import Layout from '@/components/layout';
import { config } from '@/config';
import { useGetGeneralSettingQuery, useGetWidgetAppearanceTextDetailQuery, useGetWidgetAppearanceTextQuery } from '@/redux/query';
import {
  handleSaveWidgetTextPaginationSettings,
  handleSaveWidgetTextTableSettings,
  handleSetWidgetTextDisable,
  widgetTextPaginationSettingSelector,
} from '@/redux/slice/widgetText.slice';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ManageLanguage from './component/ManageLanguage';
import { isAvailableFeature } from '@/helpers';
import { PricingPlan } from '@/constants/enum';

const Translation = () => {
  const { t } = useTranslation('translation');
  const widgetTextPaginationSetting = useSelector(widgetTextPaginationSettingSelector);
  const { data: widgetAppearanceText, isFetching: isLoadingWidgetText } = useGetWidgetAppearanceTextQuery({
    shop: config.shop,
    offset: (widgetTextPaginationSetting.page - 1) * widgetTextPaginationSetting.perPage,
    limit: widgetTextPaginationSetting.perPage,
  });

  const { data: fullWidgetAppearanceText } = useGetWidgetAppearanceTextQuery({
    shop: config.shop,
  });

  const { data: generalSettingData } = useGetGeneralSettingQuery({ shop: config.shop });

  // const { data: shopThemesData } = useGetShopThemesQuery({ shop: config.shop });

  // const mainThemeId = useMemo(() => {
  //   const themeIdArray = shopThemesData?.find((item) => item.role === ROLE_SHOP_THEME.MAIN)?.id.split('/');
  //   return themeIdArray ? Number(themeIdArray[themeIdArray.length - 1]) : undefined;
  // }, [shopThemesData]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(handleSaveWidgetTextTableSettings(widgetAppearanceText?.data.appearanceText || []));
    dispatch(
      handleSaveWidgetTextPaginationSettings({
        hasNext: widgetAppearanceText?.data.hasNextPage,
        hasPrevious: widgetAppearanceText?.data.hasPreviousPage,
      }),
    );
  }, [dispatch, fullWidgetAppearanceText?.data.appearanceText, widgetAppearanceText?.data]);

  // const defaultLanguageOption = useMemo(
  //   () => ({
  //     label: widgetAppearanceTextDetail?.data.name,
  //     value: widgetAppearanceTextDetail?.data.code,
  //   }),
  //   [widgetAppearanceTextDetail?.data.code, widgetAppearanceTextDetail?.data.name],
  // );

  useEffect(() => {
    dispatch(
      handleSetWidgetTextDisable({
        isDisableManageLanguage: !isAvailableFeature(PricingPlan.Smart, generalSettingData?.data.plan as PricingPlan),
      }),
    );
  }, [dispatch, generalSettingData?.data.plan]);

  return (
    <Layout title={t('page.title')}>
      <ManageLanguage
        isLoadingTranslationTable={isLoadingWidgetText}
        fullWidgetAppearanceText={fullWidgetAppearanceText?.data.appearanceText}
      />
    </Layout>
  );
};

export default Translation;
